<template>
  <section v-if="!loading && items.length">
    <v-container>
      <TitleWidget>
        {{ title }}
      </TitleWidget>

      <CarouselWidget
        class="mt-8 mt-md-10 events-carousel-widget"
        :items="items"
        v-bind="carouselSettings"
      >
        <template #item="{ item }">
          <EventCard v-bind="item" />
        </template>
      </CarouselWidget>
    </v-container>
  </section>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import EventCard from "../cards/EventCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "events",
  path: "/eventos",
};

const _pagination = {
  itemsPerPage: 15,
};

const _data = {
  loading: true,
  title: "Eventos",
  path: _config.path,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title, text }) => ({
        img,
        title,
        text,
        to: `${_config.path}/${formatToURL(title)}-${id}`,
      }));
    },
    carouselSettings() {
      const items = {
        itemsToShow: {
          xs: 1,
          sm: 2.5,
          md: 3,
          lg: 3,
          xl: 3,
        },
        nav: true,
      };

      if (this.smAndDown) items.gap = 12;
      else items.gap = 24;

      return items;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = { ..._pagination };

      this.$rest(_config.mod)
        .get({ params })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    "$route.path"() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    CarouselWidget,
    EventCard,
  },
};
</script>

<style lang="scss" scoped>
.events-carousel-widget::v-deep {
  .carousel-widget-nav {
    bottom: -10px;
    justify-content: flex-end !important;
    left: 12px !important;
    right: 12px !important;
    top: auto;

    .carousel-widget-nav-item-prev,
    .carousel-widget-nav-item-next {
      background-color: transparent !important;

      .v-icon {
        color: var(--v-primary-base) !important;
      }
    }
  }
}
</style>
